/**
 * Order meta keys / values consumed by the ICCT Woo Woody snippet
 * (docs/snippets/icct-wc-order-commit-woody-snippets.php — production; email + portal detection).
 * Keep keys/values in sync when that file changes. (icct-wc-order-commit-endpoints.php is not used for ICCT.)
 */
export const ICCT_ORDER_META = {
  SEND_ORDER_EMAILS: 'icct_send_order_emails',
  ORDER_SOURCE: 'order_source',
  ORDER_SOURCE_PRIVATE: '_order_source',
  YES: 'yes',
  NO: 'no',
  /** Substring matched by Woo for portal orders (created_via + order_source meta). */
  PAYMENT_PORTAL: 'payment portal',
};
